import { FacebookPixel, HelpScout } from '../../../services'

export const emailSubmitted = (config: { email: string }) => {
  // Facebook Pixel
  FacebookPixel.track('Lead', { email: config.email })

  // HelpScout
  HelpScout.identify({ name: 'Unknown', email: config.email })
}
